import styled from 'styled-components'
import { ICustomMenuItemProps } from './custom-menu-item.types'

export const MenuItem = styled.button<Partial<ICustomMenuItemProps>>`
  display: inline-block;
  text-align: left;
  width: 100%;
  height: ${({ height }) => height || '35px'};
  padding ${({ theme: { mp } }) => `${mp.sm} ${mp.sm}`};
  outline: 0;
  background-color: transparent;
  border: none;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: 0.56px;
  cursor: pointer;
  &:hover {
    background-color: ${({ theme: { palette } }) => palette.hover};
    color: ${({ theme: { palette } }) => palette.primary_600};
  }
  &:focus {
    background-color: ${({ theme: { palette } }) => palette.light};
  }
  ${({ isActive, theme: { palette } }) =>
    isActive &&
    `background-color: ${palette.light}; color: ${palette.primary}`};
`
